import { Box, Button, Grid, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import BaseLogoIcon from '../../icons/BaseLogoIcon';
import { useTranslation } from "react-i18next";
import { lighten } from "polished";

export default function BaseNav() {

    const theme = useTheme();
    const below1000 = useMediaQuery('(max-width: 1000px)');

    const { t } = useTranslation();

    return (
        <Grid container sx={{
            bgcolor: theme.palette.mode === "dark" ? lighten(0.05, theme.palette.background.paper) : "base.secondary",
            borderRadius: "20px",
            width: "100%",
            height: "97px",
            alignContent: "center",
            px: 3,
            display: below1000 ? "none" : "flex"
        }}>
            <Box sx={{ cursor: "pointer" }}>
                <BaseLogoIcon />
            </Box>
            <Link href="https://www.mobilboxmanager.info/" underline="none" color="inherit" sx={{ ml: 1.5, mt: 1.5, fontSize: "24px", fontStyle: "normal", fontWeight: 700, lineHeight: "normal", cursor: "pointer" }}>Mobilbox Manager</Link>
            
            <Link href="https://www.mobilboxmanager.info/kunden/" underline="none" color="inherit" sx={{ ml: 8, mt: 2.3, fontSize: "16px", fontStyle: "normal", textAlign: "center", fontWeight: 700, lineHeight: "normal", cursor: "pointer", '&:hover': { color: `${theme.palette.base.main}` } }}>{t("references")}</Link>
            <Link href="https://www.mobilboxmanager.info/kontakt/" underline="none" color="inherit" sx={{ ml: 6, mt: 2.3, fontSize: "16px", fontStyle: "normal", textAlign: "center", fontWeight: 700, lineHeight: "normal", cursor: "pointer", '&:hover': { color: `${theme.palette.base.main}` } }}>{t("contact")}</Link>
            <Box sx={{ flexGrow: 1 }} />
            {/* <Button
                variant="outlined"
                color="base"
                sx={{
                    borderRadius: "8px",
                    border: `2.5px solid ${theme.palette.base.main}`,
                    textTransform: "none",
                    "&:hover": {
                        border: `2.5px solid ${theme.palette.base.main}`
                    }
                }}
            >
                <Typography sx={{ fontSize: "16px", fontStyle: "normal", textAlign: "center", fontWeight: 700, lineHeight: "normal" }}>{t("try-for-free")}</Typography>
            </Button>
            <Button
                variant="contained"
                color="base"
                disableElevation
                sx={{
                    ml: 2,
                    borderRadius: "8px",
                    textTransform: "none"
                }}
            >
                <Typography sx={{ fontSize: "16px", fontStyle: "normal", textAlign: "center", fontWeight: 700, lineHeight: "normal", color: '#fff' }}>{t("login")}</Typography>
            </Button> */}
        </Grid>
    );
};
